import Vuex from 'vuex';
import moduleStore from './register-module';
import common from './modules/common';
import user from './modules/user';
// import search from './modules/search';
import track from './modules/track';
import page from './modules/page';
// 方便其他非 vue 实例引用全局状态
export let store;

export default Vue => {
    if (!store) {
        Vue.use(Vuex);
        Vue.use(moduleStore);
        store = new Vuex.Store({
            modules: {
                common,
                user,
                track,
                // search,
                page
            }
        });
    }
    if (
        typeof window.__INITIAL_STATE__ !== 'undefined' &&
        window.__INITIAL_STATE__.state
    ) {
        store.replaceState(window.__INITIAL_STATE__.state);
    }
    return store;
};
